// src/firebase/firebase.config.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore, collection, addDoc, getDocs, query, where } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage } from "firebase/storage";

// For production, use environment variables. For local/dev, you can use your config directly:
const firebaseConfig = {
    apiKey: "AIzaSyDgIjfeSaJDs5Z8Mm54SceEBtqA_MVn-4M",
    authDomain: "avinash-realtor.firebaseapp.com",
    databaseURL: "https://avinash-realtor-default-rtdb.firebaseio.com",
    projectId: "avinash-realtor",
    storageBucket: "avinash-realtor.firebasestorage.app",
    messagingSenderId: "1041838702520",
    appId: "1:1041838702520:web:2e8866917e84609213594d",
    measurementId: "G-7DHN4B6P37"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();

// Optional: Connect to local emulator for development
// Uncomment the line below to use the local Firebase emulator
// connectFunctionsEmulator(functions, "localhost", 5001);

// Updated Firestore functions for production-level structure

// Function to add a lead for a specific user
export const addLeadForUser = async (userId, leadData) => {
    const leadsCollection = collection(db, "leads");
    await addDoc(leadsCollection, { ...leadData, userId });
};

// Function to fetch leads for a specific user
export const getUserLeads = async (userId) => {
    const leadsCollection = collection(db, "leads");
    const q = query(leadsCollection, where("userId", "==", userId));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => {
        const data = doc.data() || {};
        // Derive a display `name` for UI components. Prefer existing `name`,
        // fall back to `firstName` + `lastName`, `fullName`, `leadName`, or email.
        const first = data.firstName || data.FirstName || '';
        const last = data.lastName || data.LastName || '';
        const combined = (first || last) ? `${first}${first && last ? ' ' : ''}${last}`.trim() : '';
        const name = data.name || combined || data.fullName || data.leadName || data.email || '';
        return { id: doc.id, ...data, name };
    });
};
